import React from "react";
import classNames from "classnames";
import Link, { LinkProps } from "next/link";

import IconSvg from "@/components/IconSvg";

type Props = {
  count?: number;
  disabled?: boolean;
  iconPath: string | null;
  label: string;
  lowercase?: boolean;
  showCount?: boolean;
  selected?: boolean;
  rel?: string;
} & LinkProps &
  React.HTMLAttributes<HTMLAnchorElement>;

/**
 * A button interface that's suited for use in filter interface with a small
 * number of options (e.g. strain type, effects, etc.).
 */
const TileLink = ({
  className,
  count = 0,
  disabled = false,
  iconPath,
  label,
  showCount = true,
  lowercase,
  selected,
  ...props
}: Props) => {
  const isDisabled = disabled || count === 0;

  return (
    <Link
      {...props}
      className={classNames(
        "flex flex-col items-center border-2 text-xs py-sm w-full rounded overflow-hidden",
        {
          "border-light-grey": !selected,
          "cursor-default": isDisabled,
          "cursor-pointer": !isDisabled,
          "opacity-50": isDisabled,
        },
        className,
      )}
    >
      {iconPath ? (
        <IconSvg
          height="24"
          width="24"
          className="block mb-xs"
          filePath={iconPath}
        />
      ) : null}

      <div
        className={classNames("font-bold leading-none mb-xs truncate", {
          capitalize: !lowercase,
          lowercase,
        })}
      >
        {label}
      </div>
      {showCount && (
        <div className={classNames("leading-none text-grey")}>
          ({count.toLocaleString("en-us")})
        </div>
      )}
    </Link>
  );
};

export default TileLink;
